import { render } from "./ClassificationForm.vue?vue&type=template&id=615b14f7&ts=true"
import script from "./ClassificationForm.vue?vue&type=script&lang=ts"
export * from "./ClassificationForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__